import moment from 'moment';

const DEFAULT_FORMAT = 'YYYY-MM-DD';

export const formatDate = (date: Date | string | null, format = DEFAULT_FORMAT): string | undefined => {
  if (!date) return undefined;
  return moment(date).format(format);
};
